import script from "./ScrapAlmacenLaser.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrapAlmacenLaser.vue?vue&type=script&setup=true&lang=js"

import "./ScrapAlmacenLaser.vue?vue&type=style&index=0&id=08557d16&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08557d16"]])

export default __exports__